import { type ReactNode, useCallback } from "react";

import { TenantProvider } from "@ala/account/tenant-context";
import { currentConfig } from "@ala/core/constants";
import { usePathname } from "@ala/core/navigation";
import { extractNonResourcefulPathname } from "@ala/core/utils/extract-non-resourceful-pathname";
import { randomUUID } from "@ala/core/utils/uuid";

export const TenantProviderWithRedirect = ({ children }: { children?: ReactNode }) => {
  const pathname = usePathname();

  const onTenantSwitch = useCallback(() => {
    const nonResourcefulPathname = extractNonResourcefulPathname(pathname);

    const isPlatformApp = pathname.startsWith("/app");
    if (isPlatformApp) {
      window.location.href = nonResourcefulPathname;
      return;
    }

    if (nonResourcefulPathname.startsWith("/settings")) {
      window.location.href = nonResourcefulPathname;
      return;
    }

    window.location.href = `${currentConfig.chatUrl}/conversations/${randomUUID()}`;
  }, [pathname]);

  return <TenantProvider onTenantSwitch={onTenantSwitch}>{children}</TenantProvider>;
};
